module.exports = __webpack_public_path__ + "icon_Rol_Guard.png";